import * as React from "react"
import { cn } from "@/lib/utils"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "placeholder:text-gray-400 border-gray-300 h-10 w-full min-w-0 rounded-md border bg-white px-3 py-2 text-sm shadow-sm transition-colors outline-none",
        "focus-visible:border-copper focus-visible:ring-1 focus-visible:ring-copper/30",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    />
  )
}

export { Input }
